import { z } from 'zod';

export const formSchema = z.object({
  justificationId: z.string({
    required_error: 'Selecione a justificativa',
  }),
  description: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>